import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TabPanel: {
    width: '100%',
  },
  Header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    padding: '24px 24px 0 24px',
  },
  Dashboard: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
  },
  Action: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  Switch: {
    flexDirection: 'column-reverse',
  },
  BulkActionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
}));

const buttonAddFood = {
  display: 'flex',
  padding: '10px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  '&:hover': { backgroundColor: 'var(--Primary-600, #30893C)' },
  borderRadius: '6px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
};

const buttonManageCategory = {
  display: 'flex',
  padding: '10px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  '&:hover': { backgroundColor: 'var(--Primary-50, #F2FBF3)' },
  borderRadius: '6px',
  border: '1px solid var(--Primary-50, #F2FBF3)',
  background: 'var(--Primary-50, #F2FBF3)',
};

export { buttonAddFood, buttonManageCategory, useStyles };

